import { createFileRoute } from '@tanstack/react-router';

import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/support')({
  component: RouteComponent,
  beforeLoad: () => {
    protectedRoute();
  },
});

function RouteComponent() {
  return <div>Hello /support!</div>;
}
